<template>
  <div v-if="pdfData">
    <PDFPage :src="pdfData" v-for="i in numPages" v-on:doneRendering="handleRendering" :key="i" :id="i" :page="i" />
  </div>
</template>


<script>
  import PDFPage from './PDFPage.vue';
  export default {
    components: {
      PDFPage
    },
    props: ['src'],
    data() {
      return {
        page: 1,
        numPages: 0,
        pdfData: undefined,
        pagesRendered: 0
      }
    },
    mounted() {
      this.getPDF();
    },
    watch: {
      show: (s) => {
        if (s) {
          this.getPDF();
        }
      },
      page: function(p) {
        if( window.pageYOffset <= this.findPos(document.getElementById(p)) || ( document.getElementById(p+1) && window.pageYOffset >= this.findPos(document.getElementById(p+1)) )) {
          document.getElementById(p).scrollIntoView();
        }
      }
    },
    methods: {
      handleRendering() {
        this.pagesRendered += 1;
        if (this.pagesRendered === this.numPages) {
          // once pages are done rendering we then add a unique id to each
          $('.textLayer').children('div').each(function(i) {
            $(this).attr('id', 'text-' + i)
          });
          this.$emit('doneRenderingPDF')
        }
      },
      getPDF () {
        this.pdfData = PDFPage.createLoadingTask(this.src);
        this.pdfData.then(pdf => {
          this.numPages = pdf.numPages;
          window.onscroll = function() {
            changePage()
          }

          function changePage () {
            var i = 1, count = Number(pdf.numPages);
            do {
              if(window.pageYOffset >= this.findPos(document.getElementById(i)) &&
                  window.pageYOffset <= this.findPos(document.getElementById(i+1))) {
                this.page = i
              }
              i++
            } while ( i < count)
            if (window.pageYOffset >= this.findPos(document.getElementById(i))) {
              this.page = i
            }
          }
        });
      },
      findPos(obj) {
        return obj.offsetTop;
      }
    }
  }

</script>